import React from 'react';
import { UserStateContextProvider } from './user-state-context';
import { SocketContextProvider } from './socket-context';
import { CustomerDrawerContextProvider } from './customer-drawer-context';
import { ModalContextProvider } from './modal-context';
import { BrowserNotificationsProvider } from './browser-notifications';
import { AgentContextProvider } from './agent-context';
import { NotificationsContextProvider } from './notifications-context';
import { RealtimeContextProvider } from './realtime-context';
import { SoftphoneContextProvider } from './softphone-context';
import { SoftphonePanel } from 'components/softphone/softphone-panel.component';
import { CallPopHost } from 'components/call-pop/call-pop-host.component';
export const ContextProviders = ({
  children
}) => {
  return <UserStateContextProvider>
      <NotificationsContextProvider>
        <SocketContextProvider>
          <AgentContextProvider>
            {/* Above CustomerDrawerContextProvider on purpose: that provider renders the
                customer drawer as a SIBLING of children, so anything nested below it is
                invisible to the drawer. The drawer's Dial button reads this context. */}
            <SoftphoneContextProvider>
              <CustomerDrawerContextProvider>
                {/* Inside CustomerDrawerContextProvider so a realtime event can open the drawer. */}
                <RealtimeContextProvider>
                  <ModalContextProvider>
                    <BrowserNotificationsProvider>{children}</BrowserNotificationsProvider>
                  </ModalContextProvider>
                  {/* Inside RealtimeContextProvider for the call events, and the drawer for Customer details. */}
                  <CallPopHost />
                </RealtimeContextProvider>
              </CustomerDrawerContextProvider>
              <SoftphonePanel />
            </SoftphoneContextProvider>
          </AgentContextProvider>
        </SocketContextProvider>
      </NotificationsContextProvider>
    </UserStateContextProvider>;
};